import React, { useEffect } from "react";
import { StdLanderPage } from "./pages/landing/StdLanderPage";
import { StdVideoLanderPage } from "./pages/landing/StdVideoLanderPage";
import { ValidatedPageDefinition } from "@companion-professional/dctypes";
import { CheckupRequestInfo } from "@companion-professional/dctypes";
import { StdInstructionsPage } from "./pages/instructions/StdInstructionsPage";
import { StdCaptureOrUploadPage } from "./pages/capture_or_upload/StdCaptureOrUploadPage";
import { StdSurveyPage } from "./pages/survey/StdSurveyPage";
import { trackEvent } from "../../lib/trackEvent";

interface CheckupWorkflowProps {
    checkupRequest: CheckupRequestInfo;
    uiPageDefn: ValidatedPageDefinition[];
    page: number;
}

function renderPage(defn: ValidatedPageDefinition, checkupRequest: CheckupRequestInfo, page: number) {
    switch (defn.kind) {
        case "std_lander":
            return <StdLanderPage defn={defn.config} checkupRequest={checkupRequest} page={page} />;
        case "std_video_lander":
            return <StdVideoLanderPage defn={defn.config} checkupRequest={checkupRequest} page={page} />;
        case "std_instructions":
            return <StdInstructionsPage defn={defn.config} checkupRequest={checkupRequest} page={page} />;
        case "std_video_capture":
            return <StdCaptureOrUploadPage checkupRequest={checkupRequest} page={page} />;
        case "std_survey":
            return <StdSurveyPage page={page} checkupRequest={checkupRequest} />;
        default:
            return null;
    }
}

export const CheckupWorkflow = ({ uiPageDefn, checkupRequest, page }: CheckupWorkflowProps) => {
    // the array is validated in the CheckupRoutes.tsx file
    // so need to redo the verification here
    const pageDefn = uiPageDefn[page]!;

    useEffect(() => {
        trackEvent('checkup_page_viewed', {
            page,
            page_kind: pageDefn.kind,
        });
    }, [page]);

    return (
        <>
            {renderPage(pageDefn, checkupRequest, page)}
        </>
    );
}
